import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle
} from '@mui/material'
import React from 'react'
import { PermanentDeleteIcon } from '../icons'

interface RemoveProps {
  open: boolean
  kind: string
  id: string
  name?: string
  onDelete: (id: string) => void
  onCancel: VoidFunction
  onClose: VoidFunction
}

const firstCaps = (s: string): string => {
  return s
    .split(' ')
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
    .join(' ')
}

export const Remove: React.FC<RemoveProps> = ({
  open,
  kind,
  id,
  name,
  onDelete,
  onCancel,
  onClose
}) => {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <PermanentDeleteIcon /> Delete {firstCaps(kind)}
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          {name !== undefined && name.length > 0
            ? `Deleting ${kind.toLocaleLowerCase()} ${name}`
            : 'Deleting this item'}
        </DialogContentText>
        <DialogContentText id="alert-dialog-description"></DialogContentText>
        <DialogContentText id="alert-dialog-description">
          This operation cannot be undone.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => {
            onCancel()
            onClose()
          }}
        >
          Cancel
        </Button>
        <Button
          onClick={() => {
            onDelete(id)
            onClose()
          }}
          color="error"
        >
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  )
}
